module.exports = "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec2 uv;\nattribute vec3 normal;\n\nuniform mat4 projectionMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat3 normalMatrix;\nuniform float uTime;\n\nvarying vec2 vUv;\n// varying vec3 vViewPosition;\n// varying vec3 vNormal;\n\nvoid main() {\n  vec4 viewPos = modelViewMatrix * vec4(position, 1.0);\n\n  vUv = uv;\n  gl_Position = projectionMatrix * viewPos;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/shaders/vertex.vert.glsl
// module id = MGc/
// module chunks = 1